import { APP_DATE_TIME_FORMAT } from "@/shared/lib/dateTimeFormats";
import dayjs, { type ConfigType, type Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export function parseShiftDateTime(
	value: ConfigType | null | undefined,
	tz: string,
): Dayjs | null {
	if (value === null || value === undefined || value === "") return null;
	const parsed = dayjs.utc(value).tz(tz || "UTC");
	return parsed.isValid() ? parsed : null;
}

export function formatShiftDateTime(
	value: ConfigType | null | undefined,
	tz: string,
	format = APP_DATE_TIME_FORMAT,
): string {
	return parseShiftDateTime(value, tz)?.format(format) ?? "";
}
